var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',_vm._b({attrs:{"items":[
    {
      title: 'Thứ hai',
      value: 'monday',
    },
    {
      title: 'Thứ ba',
      value: 'tuesday',
    },
    {
      title: 'Thứ tư',
      value: 'wednesday',
    },
    {
      title: 'Thứ năm',
      value: 'thursday',
    },
    {
      title: 'Thứ sáu',
      value: 'friday',
    },
    {
      title: 'Chủ nhật',
      value: 'sunday',
    } ],"item-value":"value","item-text":"title","multiple":"","chips":"","deletable-chips":"","outlined":"","hide-details":""},on:{"input":function($event){return _vm.$emit('input', $event)},"change":function (data) { return _vm.$emit('change', data); }}},'v-autocomplete',this.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }